import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Loader } from "rsuite";
import { useGetBlogsQuery } from "../../entities/Activity/activityApi";
import { formatDate } from "../../shared/helpers/formatData";
import styles from "./BlogsListing.module.scss";

export const BlogPage = () => {
	const { data = [], isLoading, isError } = useGetBlogsQuery(null);

	if (isLoading) {
		return (
			<div className={styles.loader}>
				<Helmet>
					<title>Loading Blogs | SkillerDome&apos;s Blog</title>
					<meta
						name="description"
						content="Loading the latest blog posts from SkillerDome's blog."
					/>
				</Helmet>
				<Loader center content="Loading..." vertical />
			</div>
		);
	}

	if (isError) {
		return (
			<div className={styles.error}>
				<Helmet>
					<title>Error Loading Blogs | SkillerDome&apos;s Blog</title>
					<meta
						name="description"
						content="There was an error loading the blogs. Please try again later."
					/>
				</Helmet>
				<p>Something went wrong. Please try again later.</p>
			</div>
		);
	}

	return (
		<div className={styles.blogPage}>
			<Helmet>
				<title>Blog | Insights on Development & Design</title>
				<meta
					name="description"
					content="Explore SkillerDome's blog for tips, insights, and stories about web development, design, and innovation."
				/>
				<meta
					name="keywords"
					content="Nazim Turdiyev, SkillerDome, web development blog, design tips, innovation, technology"
				/>
				<meta name="author" content="Nazim Turdiyev" />
				<link rel="canonical" href="https://skillerdome.com/blog" />
			</Helmet>

			<header className={styles.header}>
				<h1 className={styles.title}>Welcome to My Blog</h1>
				<p className={styles.subtitle}>
					Sharing insights, tips, and stories about development, design, and
					innovation.
				</p>
			</header>

			<section className={styles.posts}>
				{data.map((post) => {
					const formattedDate = formatDate(post.createdAt);
					return (
						<article key={post._id} className={styles.postCard}>
							<Link
								to={`/blog/${post._id}`}
								aria-label={`Read more about ${post.title}`}
							>
								<h2 className={styles.postTitle}>{post.title}</h2>
								<img
									src={post.image}
									alt={`Cover for the blog post titled "${post.title}"`}
									className={styles.postImage}
								/>
								<div className={styles.postMeta}>
									<span className={styles.postDate}>{formattedDate}</span>
									<span className={styles.postAuthor}>By Nazim Turdiyev</span>
								</div>
							</Link>
						</article>
					);
				})}
			</section>
		</div>
	);
};
